import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconChartUp = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={iconStyles({ ...props, className: styles.chartUp })}
  >
    <path d="M.45.47v23.12h23.13" />
    <path d="m2.2 21.59 9.79-8.07 1.66.91 7.67-9.13" />
    <path d="m19.23 5.19 2.36-.22.22 2.37" />
  </svg>
);
